import Field from 'components/Form/Field';
import KeyValue from 'components/Layout/KeyValue';
import Stacked from 'components/Layout/Stacked';
import SectionHeader from 'components/SectionHeader';
import Value from 'components/Value';
import {FC} from 'react';
import {t} from 'ttag';
import {jstDateTimeString} from 'utils/date';

type SupersendDetailsProps = {
    dateOrdered?: string;
    employeeDisplayName?: string;
};
const SupersendDetails: FC<SupersendDetailsProps> = ({
    dateOrdered,
    employeeDisplayName,
}) => (
    <Stacked>
        <SectionHeader title={t`Details`} />
        <KeyValue className="text-base">
            {dateOrdered && (
                <Field label={t`Order Date`} type="value">
                    <Value
                        value={{
                            type: 'string',
                            value: jstDateTimeString(dateOrdered),
                        }}
                    />
                </Field>
            )}
            {employeeDisplayName && (
                <Field label={t`Sender`} type="value">
                    <Value
                        value={{type: 'string', value: employeeDisplayName}}
                    />
                </Field>
            )}
        </KeyValue>
    </Stacked>
);

export default SupersendDetails;
